/************************************************************
 Physiotherapy Requisition Order Namespace
 ************************************************************/

window.physiotherapyRequisitionOrder = {
    _row: null,
    _action: null,
    _callback: null,

    executeAction: function (action, row, callback) {

        var wfId = parseInt(action.wf_id);
        var actionId = parseInt(action.wf_action_id);

        physiotherapyRequisitionOrder._action = action;
        physiotherapyRequisitionOrder._row = row;
        physiotherapyRequisitionOrder._callback = callback;

        if (actionId == globalConstants.ACTION_SCHEDULE_APPOINTMENT) {
            physiotherapyRequisitionOrder.scheduleRequisition(action, row, callback);
        } else if (actionId == globalConstants.ACTION_PRINT_REQUISITION_ORDER) {
          physiotherapyRequisitionOrder.printRequisitionOrder(action, row, callback);
        } else if (actionId == globalConstants.ACTION_CANCEL || actionId == globalConstants.ACTION_DISCONTINUE || actionId == globalConstants.ACTION_FINALIZE) {
            physiotherapyRequisitionOrder.executeGenericActionWithReason(); //IF needed, indicate a specific function to callback after reason confirm. otherwise it will go by a default function.
        } else if (actionId == globalConstants.ACTION_EDIT) {
            physiotherapyRequisitionOrder.editPhysiotherapyOrder(action, row, callback);
        }else {
            physiotherapyRequisitionOrder.executeGenericAction(action, row, callback);
        }

    },

    editPhysiotherapyOrder: function (action, row, callback) {

        Hades.loadScreen('/physiotherapy/edit_requisition_order', {order_requisition_id: row.task_id})
    },

    scheduleRequisition: function (action, row, callback) {
        Hades.loadShortcut(16, {id: row.task_id, wf_id: row.wf_id, type:'physiotherapy_order'});
    },

    printRequisitionOrder: function (action, row, callback) {
        debug.log("task_id ",row.task_id);

        var url = "/physiotherapy/requisition_sheet?requisition_id="+row.task_id+"";

        Hades.showDocument(url);

    },

    executeGenericAction: function (action, row, callback) {
        workflow.executeGenericAction(action, callback, row);
    },

    executeGenericActionWithReason: function (specific_callback) {
        workflow.openGenericReasonModal(specific_callback);
    }
};